import { dataEmpty, isArrayEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import CustomPagination from "components/CustomPagination/CustomPagination";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import {
  CustomRow,
  CustomTableContents,
  CustomTableContentsEND,
} from "components/CustomTable/tableStyle";
import NormalBtn from "components/NewButton/NormalBtn";
import { useDispatch } from "react-redux";

const UnpaidExemptResultTable = ({ searchResult, navigate, curPage, totalPage, onClickSearch }) => {
  const storesDispatch = useDispatch();
  const searchResultList = new resultTable(navigate);

  const doSearch = (page) => {
    onClickSearch(false, page);
  };

  const onClickSaveList = () => {
    simpleAlert(storesDispatch, "알림", "서비스 준비중입니다.");
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          float: "right",
          marginLeft: "auto",
          marginBottom: "0.625rem",
        }}
      >
        <NormalBtn
          name="목록 저장"
          theme="white"
          search
          onClick={() => {
            onClickSaveList();
          }}
          style={{ marginLeft: "0.5rem" }}
        />
      </div>

      <CustomTable
        columns_head={searchResultList.columns_head}
        table_title={searchResultList.table_title}
        rest_call={searchResultList.get_data_from_rest}
        row_render={searchResultList.create_table}
        rest_data={searchResult}
        // width="160rem"
      />
      <CustomPagination
        curPage={curPage}
        // pageSelection={setCurPage}
        totalCnt={totalPage}
        doSearch={doSearch}
      />
    </div>
  );
};
export default UnpaidExemptResultTable;

class resultTable {
  table_title = "";
  onNavigate = null;

  constructor(navigate) {
    this.onNavigate = navigate;
  }

  onClickRow = (data) => {
    // this.onNavigate("/staff_info/", {
    //   state: {
    //     staff_id: data.staff_id,
    //     is_view: true,
    //   },
    // });
  };

  onClickDelete = (data) => {};

  getMergedItem = (data, idx, itemLen, isCash) => {
    if (idx === 0) {
      return (
        <CustomTableContents key={data} rowSpan={itemLen} $isNumber={isCash}>
          {isCash ? data + " 원" : data}
        </CustomTableContents>
      );
    } else {
      return (
        <div
          style={{
            width: "0px",
            display: "none",
          }}
        ></div>
      );
    }
  };

  create_table = (data, idx) => {
    if (isArrayEmpty(data.purchase.unpaid.unpaid_list)) {
      return;
    }
    const itemLen = data.purchase.unpaid.unpaid_list.length;
    const isCash = true;
    return data.purchase.unpaid.unpaid_list.map((unpaidRow, index) => (
      <CustomRow
        style={{}}
        key={`exempt-row-${index}`}
        onClick={(e) => {
          if (e.target.nodeName === "DIV" || e.target.nodeName === "TD") {
            this.onClickRow(idx);
          }
        }}
        hover
      >
        {this.getMergedItem(data.branch_info.branch_name, index, itemLen)}
        {this.getMergedItem(data.member_info.member_no, index, itemLen)}
        {this.getMergedItem(data.member_info.member_name, index, itemLen)}
        {this.getMergedItem(data.search_param.base_info.phone, index, itemLen)}
        {this.getMergedItem(data.active_mbshp_info, index, itemLen)}
        {this.getMergedItem(
          data.purchase.unpaid.total_unpaid.toLocaleString(),
          index,
          itemLen,
          isCash,
        )}

        <CustomTableContents>{unpaidRow.purchase_code}</CustomTableContents>
        <CustomTableContents>{unpaidRow.payment_type}</CustomTableContents>
        <CustomTableContents>{unpaidRow.reg_date}</CustomTableContents>
        <CustomTableContents>
          {unpaidRow.unpaid_reject_info.reg_info.created_at}
        </CustomTableContents>
        <CustomTableContentsEND>
          {unpaidRow.unpaid_reject_info.reg_info.reg_name}
        </CustomTableContentsEND>
      </CustomRow>
    ));
  };

  columns_head = [
    { title: "지점", width: "8%" },
    { title: "회원번호", width: "6.5%" },
    { title: "이름", width: "7%" },
    { title: "연락처", width: "8.3%" },
    { title: "회원권 상태", width: "6.5%" },
    { title: "미납금 합계", width: "7.5%" },
    { title: "구매코드", width: "8.3%" },
    { title: "결제 구분", width: "7.5%" },
    { title: "미납일(등록일)", width: "8.3%" },
    { title: "미납금 제외 처리일", width: "9.5%" },
    { title: "미납금 제외\n처리 담당자", width: "8.3%" },
    // { title: "", width: "8.3%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
